// Marketing skin toggle: append ?skin=neutral for a generic, neutral-brand palette
// (used for company-website product screenshots). Default "aka" keeps chapter branding.
export function applySkin() {
  const params = new URLSearchParams(window.location.search);
  const q = params.get("skin");
  if (q) localStorage.setItem("cc_skin", q);
  const skin = localStorage.getItem("cc_skin") || "aka";
  document.documentElement.setAttribute("data-skin", skin);
  return skin;
}

export function currentSkin() {
  return document.documentElement.getAttribute("data-skin") || "aka";
}

// Neutral skin uses generic, product-style role labels (no chapter-specific terms).
export const NEUTRAL_ROLE_LABELS = {
  member: "Team Member",
  technology: "Technology Chairman",
  pr_chairman: "PR Chairman",
  comms_admin: "Communications",
  president: "President",
  vice_president: "Vice President",
};

// Newsletter terminology is skin-aware: the generic product says "Newsletter",
// the AEGO chapter keeps its "Sunday News" wording.
export function newsletterTerms() {
  const neutral = currentSkin() === "neutral";
  return {
    builder: neutral ? "Newsletter Builder" : "Sunday News Builder",
    submit: neutral ? "Submit Newsletter" : "Submit Sunday News",
    queue: neutral ? "Newsletter Queue" : "Sunday News Queue",
    name: neutral ? "Newsletter" : "Sunday News",
  };
}

